<div class="col-sm-12 coldx" >
	<h4>{{title}}</h4>
	<ng-template [ngIf]="altriImportiForm">
	<form [formGroup]="altriImportiForm" (ngSubmit)="save();">
	
		<div class="row">
		<div textInputCurrency class="col-sm-6"
		[labelInput]="'Costi di gestione'" [location]="'SezioneEconomica'"
		formControlName="costiGestione" [(ngModel)]="request.costiGestione"></div>
		
		<div textInputCurrency class="col-sm-6"
		[labelInput]="'Spese di registrazione'" [location]="'SezioneEconomica'"
		formControlName="speseRegistrazione" [(ngModel)]="request.speseRegistrazione"></div>
		</div>
		
		<div class="row">
		<div textInputCurrency class="col-sm-6"
		[labelInput]="'Contributo unificato'" [location]="'SezioneEconomica'"
		formControlName="contributoUnificato" [(ngModel)]="request.contributoUnificato"></div>
		
		<div textInputCurrency class="col-sm-6"
		[labelInput]="'Altro importo'" [location]="'SezioneEconomica'"
		formControlName="altroImporto" [(ngModel)]="request.altroImporto"></div>
		</div>
		
		<div class="row">
		<div textAreaInput class="form-group col-xs-12 col-sm-12"
			[labelInput]="'Note'" formControlName="note"
			[(ngModel)]="request.note"></div>
		</div>
		
		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>
		
		<div class="row">
			<div class="col-sm-3 col-xs-6">
				<p>
					<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
				</p>
			</div>
			<div class="col-sm-3 col-xs-6 col-sm-offset-6">
				<p submitButton [labelButton]="'Salva'" [disabled]="!altriImportiForm.valid"></p>
			</div>
		</div>
	</form>
	</ng-template>
</div>